import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent implements OnInit {
  @Input() titleSectionProp:any;
  @Input() List:any;

  List1 : any[] = [
    { title: 'Engineers and Developers' , content: '' ,timer: 50, currentValue:0, symbol: '+'},
    { title: 'Customers' , content: 'k' ,timer: 100, currentValue:0, symbol: '+'}
  ];
  List2 : any[] = [
    { title: 'Instances Deployed' , content: 'm' ,timer: 35, currentValue:0, symbol: '+'},
    { title: 'Support answers per month' , content: 'm' ,timer: 15, currentValue:0, symbol: '+'}
  ]
  constructor() { }

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    const duration = 5000; 
    const intervalTime = 100; 
    const steps = duration / intervalTime;
    console.log('steps', steps);
    [...this.List1, ...this.List2].forEach((list) => {
      const increment = list.timer / steps;
      let currentValue = 0;
      const interval = setInterval(() => {
        currentValue +=increment;
        list.currentValue = currentValue
        if (currentValue>= list.timer) {
          currentValue = list.timer;
          clearInterval(interval);
        }
        list.currentValue = Math.floor(currentValue)
      }, intervalTime);
    });
  }

}
